import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getSuperTask, getSubTaskList, getStepDetails } from 'visa-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { map as map$1 } from 'rxjs/operators';
import * as i2 from 'ngx-toastr';

class APILetterTemplate {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLastUsedTemplate(visaType, caseType, caseId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/templateInfo`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getI140LastUsedTemplate(superTaskId, caseId) {
        return this.httpClient.get(`/task/${superTaskId}/case/${caseId}/templateInfo`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getI140LetterTemplateList(companyId, payload) {
        return this.httpClient.post(`/company/${companyId}/documentTemplate/list`, payload).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    getAdditionalInfo(visaType, caseType, caseId, letterType, superTaskId, taskId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/additionalInfo/${letterType}?superTaskId=${superTaskId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deleteTemplateInfo(visaType, caseType, caseId, letterType, superTaskId, taskId) {
        return this.httpClient.delete(`/${visaType}/${caseType}/${caseId}/additionalInfo/${letterType}?superTaskId=${superTaskId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    postAddtionalInfo(visaType, caseType, caseId, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/additionalInfo`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    postI140AddtionalInfo(superTaskId, caseId, payload) {
        return this.httpClient.post(`/task/${superTaskId}/case/${caseId}/additionalInfo`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APILetterTemplate.ɵfac = function APILetterTemplate_Factory(t) { return new (t || APILetterTemplate)(i0.ɵɵinject(i1.HttpClient)); };
APILetterTemplate.ɵprov = i0.ɵɵdefineInjectable({ token: APILetterTemplate, factory: APILetterTemplate.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APILetterTemplate, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

// import { SubTask } from 'src/app/data/models/taskSummaryOverview.model';
class BaseLetterTemplateLibraryService {
    constructor(store, toastr, apiService) {
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.selectedTemplateObject = new EventEmitter();
        this.disabledCtrls = false;
        this.redirectionComponent = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.recordsPerPage = 25;
        this.letterTextContent = '';
        this.letterType = sessionStorage.getItem('typeOfLetter');
        // this.options.height = 200;
        this.isAdditionalInfoCoverLetter = null;
        this.additionalInfo = 'No';
        if (sessionStorage.getItem('typeOfLetter') === 'COVLTR') {
            this.isOwnTemplateUsed = sessionStorage.getItem('templateUsed') === 'OWN' ? false : true; // Dont display is user has own template
        }
        else {
            this.isOwnTemplateUsed = true;
        }
        this.docType = 'SUPLTR';
    }
    loadInit() {
        if (this.inputData.caseType === 'I130' || this.inputData.visatype === 'ASYLUM' || this.inputData.getTaskType === 'I485' || this.inputData.superTaskTypeCode === 'IMMPET') {
            this.listTemplateColumns = [
                { field: 'templateName', header: 'Template Name', },
                { field: 'documentType', header: 'Document Type' },
                { field: 'immCategoryTypeDesc', header: 'Category Type' },
                { field: 'immClassificationType', header: 'Classification Type' },
                { field: 'templateType', header: 'Template Type' },
                { field: 'isDefault', header: '' }
            ];
        }
        else {
            this.listTemplateColumns = [
                { field: 'templateName', header: 'Template Name', },
                { field: 'documentType', header: 'Document Type' },
                { field: 'visaType', header: 'Visa Type' },
                { field: 'petitionType', header: 'Petition Type' },
                { field: 'templateType', header: 'Template Type' },
                { field: 'isDefault', header: '' }
            ];
        }
        this.store.select(getSuperTask).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.superTaskDetails = data;
        });
        // Get sub task list
        this.store.pipe(select(getSubTaskList)).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.i130SubTaskList = (data.find(x => x.taskTypeCode === 'I130'));
            // this.store.dispatch(loadSubTaskDetails({ taskId: parseInt(data.find(x => x.taskTypeCode === 'I140').id.toString()) }));
        });
        if (sessionStorage.getItem('wizardTID') == null) {
            // Get Specific step details by passing step code
            this.store
                .pipe(select(getStepDetails, { id: this.inputData.stepId }))
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
                this.stepDetails = data;
                let companyId = this.stepDetails.companyId;
                if (this.inputData.caseType === 'I130') {
                    companyId = this.inputData.attorneyId;
                }
                this.getTemplateList(companyId);
                this.toggleControlsStatus();
            });
        }
        else {
            let companyId = this.inputData.companyId;
            if (this.inputData.caseType === 'I130') {
                companyId = this.inputData.attorneyId;
            }
            this.getTemplateList(companyId);
            this.toggleControlsStatus();
        }
    }
    loadAfterViewInit() {
        this.letterTemplateForm.form.valueChanges.pipe(map$1(() => this.letterTemplateForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    // Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls =
            this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" ||
                this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT";
    }
    handleToggle({ value }) {
        this.additionalInfo = value;
        if (value === 'YES') {
            this.getAdditionalInfo();
        }
    }
    handleSavePreview(type) {
        if (type === 'Save') {
            const payload = {
                additionalText: type === 'Save' ? this.letterTextContent : '',
                infoType: sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST',
            };
            if (this.inputData.caseType === 'I140') {
                this.apiService.postI140AddtionalInfo(this.inputData.superTaskId, this.inputData.caseId, payload).subscribe((response) => {
                    if (response && response.status === 200) {
                        this.toastr.success(response.message, 'Success');
                        this.redirectionComponent.emit('LetterPreview');
                        sessionStorage.setItem('templateUsed', 'TMPLT');
                    }
                });
            }
            else {
                this.apiService.postAddtionalInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, payload)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    if (response && response.status === 200) {
                        this.toastr.success(response.message, 'Success');
                        this.redirectionComponent.emit('LetterPreview');
                        sessionStorage.setItem('templateUsed', 'TMPLT');
                    }
                });
            }
        }
        else {
            this.apiService.deleteTemplateInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.letterType === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST', this.inputData.superTaskId, this.inputData.subTaskId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                // if (response && response.status === 200) {
                //   this.toastr.success(response.message);
                // }
                this.redirectionComponent.emit('LetterPreview');
                sessionStorage.setItem('templateUsed', 'TMPLT');
            });
        }
    }
    getAdditionalInfo() {
        const letterType = this.letterType === 'COVLTR' ? 'CVLTRENC' : 'PTLTRLIST';
        this.apiService.getAdditionalInfo(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, letterType, this.inputData.superTaskId, this.inputData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data && response.data) {
                this.letterTextContent =
                    response.data.find(x => x.infoTypeCode === (letterType)) ?
                        response.data.find(x => x.infoTypeCode === (letterType))['additionalText'] : '';
                this.additionalInfo = this.letterTextContent.length > 0 ? 'Yes' : 'No';
                // froalaService.insertPageBreak();
            }
        });
    }
    createNew() {
        this.redirectionComponent.emit('CreateTemplate');
    }
    getTemplateList(companyId, pageIndex = 0, recordsPerPage = this.recordsPerPage) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        let superTaskType = {};
        if (this.inputData.caseType == 'I130') {
            superTaskType['taskTypeCode'] = this.i130SubTaskList.taskTypeCode;
            superTaskType['superTaskTypeCode'] = this.i130SubTaskList.superTaskTypeCode;
        }
        else {
            superTaskType = this.getSuperTaskType;
        }
        const payload = {
            immClassificationType: ((_a = this.superTaskDetails) === null || _a === void 0 ? void 0 : _a.immigrationClassification) ? (_b = this.superTaskDetails) === null || _b === void 0 ? void 0 : _b.immigrationClassification.code : null,
            immCategoryType: ((_c = this.superTaskDetails) === null || _c === void 0 ? void 0 : _c.immigrationCategory) ? (_e = (_d = this.superTaskDetails) === null || _d === void 0 ? void 0 : _d.immigrationCategory) === null || _e === void 0 ? void 0 : _e.code : null,
            petitionType: ((_f = this.superTaskDetails) === null || _f === void 0 ? void 0 : _f.petitionType) ? (_g = this.superTaskDetails) === null || _g === void 0 ? void 0 : _g.petitionType.code : this.inputData.taskTypeDetails ? (_h = this.inputData.taskTypeDetails) === null || _h === void 0 ? void 0 : _h.petitionType : null,
            taskTypeRefId: superTaskType ? superTaskType['taskTypeCode'] : ((_j = this.inputData) === null || _j === void 0 ? void 0 : _j.caseType) ? (_k = this.inputData) === null || _k === void 0 ? void 0 : _k.caseType : this.inputData.superTaskTypeCode ? this.inputData.superTaskTypeCode : null,
            superTaskTypeId: superTaskType ? superTaskType['superTaskTypeCode'] : this.inputData.superTaskTypeCode ? this.inputData.superTaskTypeCode : null,
            visaType: ((_l = this.superTaskDetails) === null || _l === void 0 ? void 0 : _l.immigrationCategory) ? null : this.inputData.visatype,
            isDefault: null,
            pageNumber: 0,
            pageSize: 0,
            pageIndex,
            recordsPerPage,
            searchText: '',
            documentType: sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? 'COVLTR' : 'SUPLTR',
            taskTypeId: this.inputData.taskTypeId,
            taskId: ((_m = this.inputData) === null || _m === void 0 ? void 0 : _m.taskId) || ((_o = this.inputData) === null || _o === void 0 ? void 0 : _o.subTaskId) || null
        };
        this.apiService.getI140LetterTemplateList(companyId, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (this.inputData.caseType === 'I140') {
                this.apiService.getI140LastUsedTemplate(this.inputData.superTaskId, this.inputData.caseId)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((lastUsedTemplateResponse) => {
                    this.lastUsedTemplateId = sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? lastUsedTemplateResponse.data['coverLetterTemplateId'] : lastUsedTemplateResponse.data['supportLetterTemplateId'];
                    this.selectedTemplateObject.emit(sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? lastUsedTemplateResponse.data['coverLetterTemplateId'] : lastUsedTemplateResponse.data['supportLetterTemplateId']);
                });
            }
            else {
                this.apiService.getLastUsedTemplate(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((lastUsedTemplateResponse) => {
                    this.lastUsedTemplateId = sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? lastUsedTemplateResponse.data['coverLetterTemplateId'] : lastUsedTemplateResponse.data['supportLetterTemplateId'];
                    this.selectedTemplateObject.emit(sessionStorage.getItem('typeOfLetter') === 'COVLTR' ? lastUsedTemplateResponse.data['coverLetterTemplateId'] : lastUsedTemplateResponse.data['supportLetterTemplateId']);
                });
            }
            if (response['data']['documentTemplate'] && response['data']['documentTemplate'].length > 0) {
                this.templateList =
                    response['data']['documentTemplate'].filter(x => (x['companyId'] == companyId ||
                        x['companyId'] == '') && (x['documentType'] === sessionStorage.getItem('typeOfLetter')));
            }
            else {
                this.templateList = [];
            }
        });
    }
    onRowExpand(event) {
        sessionStorage.setItem('documentTemplateId', event.data.id);
        this.getAdditionalInfo();
    }
    handleBack() {
        this.redirectionComponent.emit('CreateTemplate');
    }
    handlePageSettingsChange(event) {
        this.getTemplateList(this.stepDetails.companyId, event.page, this.recordsPerPage);
    }
    loadDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseLetterTemplateLibraryService.ɵfac = function BaseLetterTemplateLibraryService_Factory(t) { return new (t || BaseLetterTemplateLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(APILetterTemplate)); };
BaseLetterTemplateLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseLetterTemplateLibraryService, factory: BaseLetterTemplateLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseLetterTemplateLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.ToastrService }, { type: APILetterTemplate }]; }, { data: [{
            type: Input
        }], selectedTemplateObject: [{
            type: Output
        }], disabledCtrls: [{
            type: Input
        }], selectedTemplateId: [{
            type: Input
        }], redirectionComponent: [{
            type: Output
        }] }); })();

/*
 * Public API Surface of base-letter-template-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APILetterTemplate, BaseLetterTemplateLibraryService };
//# sourceMappingURL=base-letter-template-library.js.map
